import { render, staticRenderFns } from "./ziInvestmentMoreInfo.vue?vue&type=template&id=757d9ce8&scoped=true&"
import script from "./ziInvestmentMoreInfo.vue?vue&type=script&lang=js&"
export * from "./ziInvestmentMoreInfo.vue?vue&type=script&lang=js&"
import style0 from "./ziInvestmentMoreInfo.vue?vue&type=style&index=0&id=757d9ce8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "757d9ce8",
  null
  
)

export default component.exports